export default function BackgammonIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="6" width="56" height="52" rx="6" fill="#6B4423" />
      <rect x="8" y="10" width="48" height="44" rx="2" fill="#1F6B4A" />
      <path d="M8 10h8l-4 18zM24 10h8l-4 18zM40 10h8l-4 18z" fill="#E9D2A6" />
      <path d="M16 10h8l-4 18zM32 10h8l-4 18zM48 10h8l-4 18z" fill="#B5462F" />
      <path d="M8 54h8l-4-18zM24 54h8l-4-18zM40 54h8l-4-18z" fill="#B5462F" />
      <path d="M16 54h8l-4-18zM32 54h8l-4-18zM48 54h8l-4-18z" fill="#E9D2A6" />
      <circle cx="12" cy="49" r="4.5" fill="#2F8BFF" stroke="#164787" strokeWidth="1.5" />
      <circle cx="12" cy="40" r="4.5" fill="#2F8BFF" stroke="#164787" strokeWidth="1.5" />
      <circle cx="52" cy="15" r="4.5" fill="#FF8A1F" stroke="#8A4410" strokeWidth="1.5" />
      <circle cx="52" cy="24" r="4.5" fill="#FF8A1F" stroke="#8A4410" strokeWidth="1.5" />
      <rect x="24" y="25" width="13" height="13" rx="3" fill="#fff" stroke="#1D2433" strokeWidth="1.5" transform="rotate(-12 30 31)" />
      <circle cx="27.5" cy="29" r="1.5" fill="#1D2433" />
      <circle cx="32.5" cy="33" r="1.5" fill="#1D2433" />
      <rect x="36" y="31" width="11" height="11" rx="3" fill="#fff" stroke="#1D2433" strokeWidth="1.5" transform="rotate(14 41 36)" />
      <circle cx="41.5" cy="36.5" r="1.5" fill="#1D2433" />
    </svg>
  );
}
